module.exports = __webpack_public_path__ + "static/img/scene.64a9e823.png";